import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from '../../services/authService';
import PageHeader from '../common/PageHeader';
import './ChineseLearn.css';

interface ChineseLearnProps {
  user: User | null;
  onClose: () => void;
  onToggleSidebar: () => void;
}

const ChineseLearn: React.FC<ChineseLearnProps> = ({
  onToggleSidebar
}) => {
  const navigate = useNavigate();

  return (
    <div className="chinese-learn-container">
      <PageHeader
        onToggleSidebar={onToggleSidebar}
        centerContent={
          <h1 className="page-header-center-title">
            Chinese Learning
          </h1>
        }
      />

      <div className="chinese-learn-content">
        <div className="chinese-learn-section">
          <div className="chinese-learn-section-header">/modules</div>
          <div className="chinese-learn-buttons">
            <button
              className="chinese-learn-module-btn chinese-learn-reading-btn"
              onClick={() => navigate('/chinese/reading')}
            >
              <span className="chinese-learn-module-icon">📖</span>
              <span className="chinese-learn-module-title">Reading</span>
              <span className="chinese-learn-module-description">
                AI-powered Chinese reading lessons with interactive vocabulary
              </span>
            </button>
            <button
              className="chinese-learn-module-btn chinese-learn-practice-btn"
              onClick={() => navigate('/chinese/practice')}
            >
              <span className="chinese-learn-module-icon">✏️</span>
              <span className="chinese-learn-module-title">Practice Translation</span>
              <span className="chinese-learn-module-description">
                Practice translating English to Chinese with AI feedback
              </span>
            </button>
            <button
              className="chinese-learn-module-btn chinese-learn-character-btn"
              onClick={() => navigate('/chinese/character')}
            >
              <span className="chinese-learn-module-icon">🖋️</span>
              <span className="chinese-learn-module-title">Character Writing</span>
              <span className="chinese-learn-module-description">
                Practice writing Chinese characters with AI verification
              </span>
            </button>
            <button
              className="chinese-learn-module-btn chinese-learn-writing-copilot-btn"
              onClick={() => navigate('/chinese/writing-copilot')}
            >
              <span className="chinese-learn-module-icon">✍️</span>
              <span className="chinese-learn-module-title">Writing Copilot</span>
              <span className="chinese-learn-module-description">
                Write Chinese text with AI assistance that continues your writing
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChineseLearn;
